import React from "react";
import Shuffler from "./Shuffler";

function App() {
  return (
    <div className="absolute bottom-0 top-0 left-0 right-0 flex flex-col items-center justify-end sm:justify-center">
      <Shuffler />
    </div>
  );
}

export default App;
